import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-078fa504"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["colspan"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-table-container" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'tableSkeleton',
  props: {
  columnsNumber: {
    type: Number,
    required: false,
    default: 0,
  },
  rowsNumber: {
    type: Number,
    required: false,
    default: 3,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: __props.rowsNumber }, (v, i) => i), (item) => {
    return (_openBlock(), _createElementBlock("tr", {
      key: item,
      class: "skeleton-tr tr-empty"
    }, [
      _createElementVNode("td", {
        colspan: __props.columnsNumber + 1,
        class: "skeleton-td custom-global-skeleton"
      }, _hoisted_3, 8, _hoisted_1)
    ]))
  }), 128))
}
}

})